<ng-container *ngIf="masterProduct$ | async as master; else noProduct">
  <kion-product-detail
    *ngIf="product$ | async as product"
    [product]="product"
    [masterProduct]="master"
    [addingToBasket]="addingToBasket"
    (addToBasket)="addToBasket($event)"
  ></kion-product-detail>
</ng-container>
<ng-template #noProduct>
  No Product Found
</ng-template>
